import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const RollOutContext = createContext();

export const useRollOut = () => {
  const context = useContext(RollOutContext);
  if (!context) {
    throw new Error('useRollOut must be used within a RollOutProvider');
  }
  return context;
};

export const RollOutProvider = ({ children }) => {
  const [filterSections, setFilterSections] = useState([]);
  const [environmentGroups, setEnvironmentGroups] = useState([
    {
      name: 'Production',
      units: [] // Will be populated from Firestore
    },
    {
      name: 'Non-production',
      units: [] // Will be populated from Firestore
    }
  ]);
  const [nonProductionUnits, setNonProductionUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Get all filter sections
        const sectionsCollection = collection(db, 'unit_filter_sections');
        const sectionsSnapshot = await getDocs(sectionsCollection);
        
        const sections = await Promise.all(sectionsSnapshot.docs.map(async (sectionDoc) => {
          const sectionData = sectionDoc.data();
          
          // Get groups for this section
          const groupsCollection = collection(db, `unit_filter_sections/${sectionDoc.id}/groups`);
          const groupsSnapshot = await getDocs(groupsCollection);
          
          const groups = groupsSnapshot.docs.map(groupDoc => ({
            name: groupDoc.data().name,
            units: groupDoc.data().unit_ids || []
          }));

          return {
            title: sectionData.name,
            groups
          };
        }));

        setFilterSections(sections);

        // Get environment groups
        const envGroupsCollection = collection(db, 'unit_filter_environments');
        const envGroupsSnapshot = await getDocs(envGroupsCollection);

        const envGroups = envGroupsSnapshot.docs.map(doc => ({
          name: doc.data().name,
          units: doc.data().unit_ids || []
        }));

        setEnvironmentGroups(envGroups);

        const nonProductionDoc = await getDoc(doc(db, 'unit_filter_sections_non_production', 'non_production'));
        if (nonProductionDoc.exists()) {
          setNonProductionUnits(nonProductionDoc.data().unit_ids || []);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <RollOutContext.Provider value={{ filterSections, environmentGroups, nonProductionUnits, loading }}>
      {children}
    </RollOutContext.Provider>
  );
}; 